// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ClaimReview_wrapper__2Xvqo","textareaContainer":"ClaimReview_textareaContainer__2lkM9"};